import { render, staticRenderFns } from "./DashboardWidgetAccountWindow.vue?vue&type=template&id=3492a4f3&scoped=true"
import script from "./DashboardWidgetAccountWindow.vue?vue&type=script&lang=js"
export * from "./DashboardWidgetAccountWindow.vue?vue&type=script&lang=js"
import style0 from "./DashboardWidgetAccountWindow.vue?vue&type=style&index=0&id=3492a4f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3492a4f3",
  null
  
)

export default component.exports